<template>
  <section>
    <div class="container">
      <section class="job-ad">
        <Spinner :isLoading="isLoading" />
        <div class="row">
          <div class="col-md-8">
            <span @click="$router.go(-1)" class="to-jobs">Back to jobs list</span>
            <h1>{{ singleJob.title }}</h1>
            <span class="employment"
              ><i class="fas fa-building"></i> {{ singleJob.employer_name }}</span
            >
            <span v-if="singleJob.address" class="type"
              ><i class="fas fa-map-marker-alt"></i> {{ singleJob.address.city.name }},
              {{ singleJob.address.country.name }}</span
            >
            <span class="employment"
              ><i class="fas fa-handshake"></i>
              {{ employmentType(singleJob.employment_type) }}</span
            >
            <span class="employment"
              ><i class="fas fa-briefcase"></i> {{ showWorkPlace(singleJob.workplace) }}</span
            >
            <hr />
            <div v-html="singleJob.description"></div>
          </div>
          <div class="col-md-4">
            <div class="box sticky-top">
              <button
                v-if="!singleJob.exist_in_pipeline && !showButton"
                class="btn btn-success btn-block"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
                @click="setDefaultDocument()"
              >
                Apply Now
              </button>
              <button disabled v-else class="btn btn-success btn-block">Already applied</button>
              <h3>More Openings</h3>
              <ul v-if="singleJob.more_openings" class="list-unstyled">
                <li v-for="more in singleJob.more_openings" :key="more.id">
                  <router-link
                    @click.native="reload()"
                    class="d-flex flex-wrap"
                    :to="{ name: 'user-jobs', params: { jobad_id: more.id } }"
                    ><span>{{ more.title }}</span>
                    <span
                      >{{ more.address.country.name }}, {{ more.address.city.name }}</span
                    ></router-link
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Job location Modal -->
        <!-- End job location Modal -->
      </section>
    </div>
    <div
      class="modal fade"
      id="staticBackdrop"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div v-if="step === 1" class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fs-5" id="staticBackdropLabel">Apply for Job</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="close-modal"
              @click="clearDocuments()"
            ></button>
          </div>
          <div class="modal-body">
            <p class="mb-4">
              You can apply for a job with your LinkedIn profile and/or by submitting your CV and
              other documents.
            </p>
            <div class="form-group m-label-left">
              <input
                v-model="linkedIn"
                type="text"
                class="form-control"
                placeholder="Not entered"
                id="linkedin"
              />
              <label class="nofprmat" for="linkedin">LinkedIn</label>
            </div>
            <ul class="list-unstyled apply-documents row">
              <li class="col-md-6" v-for="file in getUserProfile.documents" :key="file.id">
                <div class="custom-control custom-checkbox">
                  <input
                    :id="file.id"
                    class="custom-control-input"
                    type="checkbox"
                    v-model="selectedDocuments"
                    :value="file.id"
                    aria-label
                  />
                  <label class="custom-control-label" :for="file.id">
                    <p class="visually-hidden" style="width: 0px;">
                      <i style="color: red" :class="`fa ${file.icon}`"></i> {{ file.name }}
                    </p>
                  </label>
                  <popper
                    trigger="hover"
                    :options="{
                      placement: 'top',
                      modifiers: { offset: { offset: '0,10px' } },
                    }"
                  >
                    <div class="popper">
                      {{ file.name }}
                    </div>
                    <div slot="reference">
                      <a
                        class="text-truncate fake-link"
                        href="#"
                        @click="onOpenDocPreview(file.id, file.name)"
                      >
                        <i
                          :style="
                            file.name.split('.').pop() === 'pdf' ? `color: red` : `color:#4073c4`
                          "
                          :class="`fa ${file.icon}`"
                        ></i>
                        {{ file.name }}
                      </a>
                    </div>
                  </popper>
                </div>
              </li>
            </ul>

            <div id="add-document-form">
              <div class="row justify-content-center">
                <div class="col-md-11">
                  <form ref="fileForm" enctype="multipart/form-data">
                    <div class="dropzone p-4">
                      <div class="dropzone-message file-drag-drop">
                        <p class="small drop-files">
                          Drag your CV and other files that you want to include in your application
                          here or click to browse for files.
                        </p>
                        <!--                         <ul class="list-group file-listing mt-3">
                          <li
                            v-for="(file, key) in candidateDocumentsFiles"
                            :key="key"
                            class="list-group-item d-flex align-items-center small"
                          >
                            <span class="mr-auto">{{ file.name }}</span>
                            <span class="badge badge-primary badge-pill ml-auto">{{
                              `${(file.size / 1024 / 1024).toFixed(2)} MB`
                            }}</span>
                            <span class="remove-container ml-4">
                              <span
                                class="remove"
                                style="cursor: pointer"
                                v-on:click="removeFile(key)"
                                >×</span
                              >
                            </span>
                          </li>
                        </ul> -->
                        <div class="d-grid mt-3 w-50 mx-auto">
                          <label
                            for="candidate-files"
                            class="btn btn-primary btn-sm file-upload-label"
                            style="padding: 6.5px 15px; margin-bottom: 0"
                            >Browse</label
                          >
                        </div>
                        <input
                          type="file"
                          id="candidate-files"
                          ref="candidateDocumentsFiles"
                          name="candidateDocumentsFiles"
                          @input="handleCandidateDocumentsFileUpload"
                          class="file-upload-input"
                          accept=".doc,.docx,.pdf,.odt"
                          multiple
                        />

                        <div v-if="uploadPercentage < 100 && isUploading" class="small">
                          <progress max="100" :value.prop="uploadPercentage" />
                          <div>{{ `${uploadPercentage}%` }}</div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="col-md-7 mx-auto">
              <button @click="checkDraft" class="btn btn-success btn-block">
                Draft a cover letter with AI
              </button>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button
              :disabled="isApp"
              type="button"
              @click="updateLinkedIn()"
              class="btn btn-secondary"
            >
              Apply
            </button>
            <button
              @click="clearDocuments()"
              type="button"
              data-bs-dismiss="modal"
              class="btn btn-primary"
            >
              Cancel
            </button>
          </div>
        </div>

        <div v-if="step === 2" class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fs-5" id="staticBackdropLabel">Draft a cover letter with AI</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="close-modal"
              @click="stepController"
            ></button>
          </div>
          <div class="modal-body">
            <Spinner :isLoading="isAiLoading" />
            <div class="form-group m-label-left">
              <input
                disabled
                type="text"
                class="form-control"
                id="draftJob"
                :value="
                  `
    ${singleJob.title},
    ${singleJob.employer_name}
  `
                "
              />
              <label for="draftJob">Job</label>
            </div>

            <div class="form-group m-label-left mt-4">
              <select v-model="selectedLanguageForAI" id="lang" class="form-select">
                <option value="bg">Bulgarian</option>
                <option value="zh_Hans">Chinese (Simplified)</option>
                <option value="zh_Hant">Chinese (Traditional)</option>
                <option value="cs">Czech</option>
                <option value="da">Danish</option>
                <option value="nl">Dutch</option>
                <option value="en">English</option>
                <option value="fi">Finnish</option>
                <option value="fr">French</option>
                <option value="de">German</option>
                <option value="el">Greek</option>
                <option value="hu">Hungarian</option>
                <option value="it">Italian</option>
                <option value="ja">Japanese</option>
                <option value="ko">Korean</option>
                <option value="no">Norwegian</option>
                <option value="pl">Polish</option>
                <option value="pt">Portuguese</option>
                <option value="ro">Romanian</option>
                <option value="ru">Russian</option>
                <option value="es">Spanish</option>
                <option value="sv">Swedish</option>
                <option value="tr">Turkish</option>
                <option value="uk">Ukrainian</option>
              </select>
              <label for="lang">Language</label>
            </div>

            <div class="form-group m-label-left mt-4">
              <textarea
                v-model="motivation"
                placeholder="To enhance the quality of the letter, it's great if you provide a brief explanation of why you believe you are well-suited for the role and what makes this opportunity exciting for you."
                rows="4"
                class="form-control"
                id="motivation"
              ></textarea>
              <label for="motivation">Short motivation</label>
            </div>

            <div class="form-group m-label-left mt-4">
              <select v-model="competenceProfile" id="profile" class="form-select">
                <option value="1" disabled>Please select competence profile</option>
                <option v-for="file in getUserProfile.documents" :key="file.id" :value="file.id">{{
                  file.name
                }}</option>
              </select>
              <label for="profile">Competence profile</label>
            </div>

            <p style="font-size: 15px;">
              The cover letter will be generated based on your competence profile (a CV is
              recommended), aligned with the job description and your motivation provided above.
            </p>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button
              :disabled="isAiLoading"
              type="button"
              @click="generateCoverLetter"
              class="btn btn-secondary"
            >
              Generate
            </button>
            <button @click="stepController" type="button" class="btn btn-primary">
              Cancel
            </button>
          </div>
        </div>

        <div v-if="step === 3" class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fs-5" id="staticBackdropLabel">Draft a cover letter with AI</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="close-modal"
              @click="stepController"
            ></button>
          </div>
          <div class="modal-body">
            <Spinner :isLoading="isAiLoading" />
            <div class="form-group m-label-left mt-4">
              <TextEditor v-model="generatedText.reply" />
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button
              :disabled="isAiLoading"
              type="button"
              @click="generateCoverLetterPdf"
              class="btn btn-secondary"
            >
              Generate
            </button>
            <button @click="stepController" type="button" class="btn btn-primary">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Pagination from '../Navigations/Pagination';
import axios from 'axios';
import { selectDefaultDocument } from '../../mixins/selectDefaultDocumentMixin';
import TextEditor from '../common/TextEditor.vue';
const MAX_FILE_SIZE = 20;
export default {
  data() {
    return {
      isLoading: true,
      singleJob: [],
      city: '',
      country: '',
      showButton: false,
      selectedDocuments: [],
      candidateDocumentsFiles: [],
      linkedIn: null,
      uploadPercentage: 0,
      isUploading: false,
      jobId: '',
      isPrimary: false,
      isApp: false,
      selectedLanguageForAI: 'en',
      motivation: '',
      step: 1,
      generatedText: '',
      competenceProfile: '1',
      isAiLoading: false,
    };
  },
  components: {
    TextEditor,
  },
  methods: {
    ...mapActions(['retrieveCandidateUserProfile', 'retrieveCandidateDocumentPreview']),
    reload() {
      this.getSingleJob();
    },

    stepController() {
      this.step = 1;
      this.selectedLanguageForAI = 'en';
      this.motivation = '';
      this.competenceProfile = '1';
      document.querySelectorAll('.ql-toolbar').forEach(toolbar => {
        if (!toolbar.closest('[v-cloak]')) {
          toolbar.remove();
        }
      });
      this.isAiLoading = false;
    },

    getLanguageLabel(value) {
      const languageMap = {
        bg: 'Bulgarian',
        zh_Hans: 'Chinese (Simplified)',
        zh_Hant: 'Chinese (Traditional)',
        cs: 'Czech',
        da: 'Danish',
        nl: 'Dutch',
        en: 'English',
        fi: 'Finnish',
        fr: 'French',
        de: 'German',
        el: 'Greek',
        hu: 'Hungarian',
        it: 'Italian',
        ja: 'Japanese',
        ko: 'Korean',
        no: 'Norwegian',
        pl: 'Polish',
        pt: 'Portuguese',
        ro: 'Romanian',
        ru: 'Russian',
        es: 'Spanish',
        sv: 'Swedish',
        tr: 'Turkish',
        uk: 'Ukrainian',
      };
      return languageMap[value] || 'Unknown';
    },
    checkDraft() {
      if (
        this.getUserProfile.documents.length === 0 &&
        (this.linkedIn === null || this.linkedIn === '')
      ) {
        this.$toasted.error(
          ' Please add your LinkedIn profile or upload your CV to draft a cover letter',
          {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          },
        );
      } else {
        this.step = 2;
      }
    },

    generateCoverLetter() {
      if (this.competenceProfile === '1') {
        this.$toasted.error(' Please select competence profile', {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
        return false;
      }
      this.isAiLoading = true;
      axios(`${process.env.VUE_APP_API_URL}/candidate/generatecoverletter`, {
        method: 'post',
        data: {
          document_id: this.competenceProfile,
          candidate_motivitional_text: this.motivation,
          job_id: this.singleJob.id,
          languague: this.getLanguageLabel(this.selectedLanguageForAI),
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(res => {
          this.generatedText = res.data;
          this.isAiLoading = false;
          this.step = 3;
        })
        .catch(err => {
          this.isAiLoading = false;
        });
    },

    generateCoverLetterPdf() {
      this.isAiLoading = true;
      let htmlContent = this.generateHtmlString();
      axios(`${process.env.VUE_APP_API_URL}/candidate/adobe/generatepdf`, {
        method: 'post',
        data: {
          job_id: this.singleJob.id,
          html: htmlContent,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(res => {
          this.retrieveCandidateUserProfile().then(() => {
            this.selectedDocuments.push(res.data.document_id);
            this.stepController();
          });
        })
        .catch(err => {
          this.isAiLoading = false;
        });
    },
    setDefaultDocument() {
      this.linkedIn = this.getUserProfile.linkedin;
      if (this.getUserProfile.linkedin === null) {
        this.linkedIn = null;
      }
      if (this.getUserProfile.documents.length > 0) {
        const primaryDoc = this.getUserProfile.documents.find(
          document => document.is_default === true,
        );
        this.selectedDocuments.push(primaryDoc.id);
      }
    },
    clearDocuments() {
      this.selectedDocuments = [];
    },

    disableIntro() {
      axios(`${process.env.VUE_APP_API_URL}/candidate/updateintroscreen`, {
        method: 'post',
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });
    },
    applyFodarJob() {
      /*       if (this.selectedDocuments.length === 0 && this.linkedIn === null) {
        this.$toasted.error(
          'Please add a link to your LinkedIn profile or select at least one uploaded file in order to complete the application.',
          {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          },
        );
        return false;
      }
      if (this.linkedIn !== this.getUserProfile.linkedin) {
        if (
          this.linkedIn.length > 0 &&
          !this.linkedIn.match(
            /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
          )
        ) {
          this.$toasted.error('Please enter valid LinkedIn profile url.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
          return false;
        } else {
          this.updateLinkedIn();
        }
      } */
    },

    applyForJob() {
      if (this.selectedDocuments.length === 0 && this.linkedIn === null) {
        this.$toasted.error(
          'Please add a link to your LinkedIn profile or select at least one uploaded file in order to complete the application',
          {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          },
        );
        return false;
      }
      if (this.linkedIn !== null) {
        if (
          this.linkedIn.length > 0 &&
          !this.linkedIn.match(
            /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
          )
        ) {
          this.$toasted.error('Please enter valid LinkedIn profile url.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
          return false;
        }
      }
      this.isApp = true;
      axios(`${process.env.VUE_APP_API_URL}/candidate/createapplication`, {
        method: 'post',
        data: {
          js_employer_jobad_id: this.$route.params.jobad_id,
          documents_ids: this.selectedDocuments,
          linkedin: this.linkedIn,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          this.showButton = true;
          this.isApp = false;
          this.$toasted.success('You successfully applied.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
          this.$refs['close-modal'].click();
          this.disableIntro();
        })
        .catch(error => {
          this.isApp = false;
          console.log(error);
        });
    },

    showWorkPlace(data) {
      if (data === 1) {
        return 'Onsite';
      } else if (data === 2) {
        return 'Hybrid';
      } else {
        return 'Remote';
      }
    },

    updateLinkedIn() {
      if (this.linkedIn !== this.getUserProfile.linkedin) {
        if (
          this.linkedIn.length > 0 &&
          !this.linkedIn.match(
            /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
          )
        ) {
          this.$toasted.error('Please enter valid LinkedIn profile url.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
          return false;
        }
        axios(`${process.env.VUE_APP_API_URL}/candidate/update`, {
          method: 'post',
          data: {
            first_name: this.getUserProfile.first_name,
            last_name: this.getUserProfile.last_name,
            linkedin: this.linkedIn,
            city_id: this.getUserProfile.city_id,
            country_id: this.getUserProfile.country_id,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }).then(() => {
          this.applyForJob();
        });
      } else {
        this.applyForJob();
      }
    },

    getSingleJob() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/candidate/viewjob/${this.$route.params.jobad_id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          this.isLoading = false;
          this.singleJob = data;
          this.city = data.address.city.name;
          this.country = data.address.country.name;
          this.jobId = data.id;
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    employmentType(employment) {
      if (employment === 1) {
        return 'Employment';
      } else if (employment === 2) {
        return 'Self-employment';
      } else if (employment === 3) {
        return 'Employment / Self-Employment';
      }
    },

    setAsDefault(e) {
      this.itemId = e.target.id;
    },
    handleFileUpload() {
      const uploadedFiles = this.$refs.files.files;

      for (let i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i]);
      }

      this.$refs.fileForm.reset();
    },
    removeFile(key) {
      this.files.splice(key, 1);
    },
    cancelUpload() {
      this.errorMessage = '';
      this.files = [];
      this.showModal = false;
    },
    determineDragAndDropCapable() {
      let div = document.createElement('div');

      return (
        ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) &&
        'FormData' in window &&
        'FileReader' in window
      );
    },
    handleCandidateDocumentsFileUpload() {
      const uploadedFiles = this.$refs['candidateDocumentsFiles'].files;

      for (let i = 0; i < uploadedFiles.length; i++) {
        this.candidateDocumentsFiles.push(uploadedFiles[i]);
      }

      this.$refs.fileForm.reset();

      for (let i = 0; i < this.candidateDocumentsFiles.length; i++) {
        const file = this.candidateDocumentsFiles[i];

        const fileSize = (file.size / 1024 / 1024).toFixed(2);

        if (fileSize > MAX_FILE_SIZE) {
          this.errorMessage = `The file size exceeds the limit of 20 MB.`;
        }
      }
      this.submitFiles();
    },

    onOpenDocPreview(docId) {
      let preview = true;
      this.retrieveCandidateDocumentPreview({ uuid: docId, preview: preview }).then(response => {
        const blob = new window.Blob([response.data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    },

    onDownloadDocument(docId, docTitle) {
      this.retrieveCandidateDocumentPreview({ uuid: docId })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', `${docTitle}`);
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch(err => {
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },

    submitFiles() {
      this.isUploading = true;

      const formData = new FormData();
      for (let i = 0; i < this.candidateDocumentsFiles.length; i++) {
        const file = this.candidateDocumentsFiles[i];

        const fileSize = (file.size / 1024 / 1024).toFixed(2);

        if (fileSize > MAX_FILE_SIZE) {
          this.errorMessage = `The file size exceeds the limit of ${MAX_FILE_SIZE} MB.`;
        } else {
          if (
            this.getUserProfile.documents.length === 0 ||
            !this.getUserProfile.documents.some(doc => doc.is_default)
          ) {
            if (i === 0) {
              this.isPrimary = true;
            } else {
              this.isPrimary = false;
            }
          }

          formData.append(`file_${i}`, file);
          formData.append(`primary_${i}`, this.isPrimary);
        }
      }

      formData.append('files_count', this.candidateDocumentsFiles.length);
      /*    formData.append('js_candidate_id', this.$route.params.candidate_id); */

      if (this.candidateDocumentsFiles.length) {
        axios
          .post(`${process.env.VUE_APP_API_URL}/candidate/documents/upload`, formData, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
              'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: progressEvent => {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total),
              );
            },
          })
          .then(() => {
            this.isUploading = false;
            this.uploadPercentage = 0;
            this.errorMessage = '';
            this.retrieveCandidateUserProfile().then(({ data }) => {
              const result = data.documents.map(f => ({ id: f.id, name: f.name }));
              for (let i = 0; i < result.length; i++) {
                const elementu = result[i];
                for (let v = 0; v < this.candidateDocumentsFiles.length; v++) {
                  const element = this.candidateDocumentsFiles[v];
                  if (elementu.name === element.name) {
                    this.selectedDocuments.push(elementu.id);
                  }
                }
              }
              this.candidateDocumentsFiles = [];
            });
          })
          .catch(err => {
            this.candidateDocumentsFiles = [];
            if (err.response.data === 'You can have a maximum of 20 documents') {
              this.$toasted.error(`Document limit reached. Delete existing ones to add more`, {
                theme: 'bubble',
                icon: 'fa-check-circle',
                position: 'bottom-right',
                duration: 5000,
              });
            } else {
              this.$toasted.error(`${err}`, {
                theme: 'bubble',
                icon: 'fa-check-circle',
                position: 'bottom-right',
                duration: 5000,
              });
            }

            this.isUploading = false;
            this.uploadPercentage = 0;
          });
      }
    },

    generateHtmlString() {
      return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Cover Letter</title>
    <style>
    @import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');
        .freelancing-container {
           font-family: "Lato", sans-serif;
           padding:40px;
        }
        .freelancing-container p {
          font-size: 14px
        }
        .freelancing-container  h2 {
          font-size:18px;
          font-weight:800;
        }
        .freelancing-container  h3 {
          font-weight:800;
          font-size:13px;
          margin-bottom:20px;
          margin-top:20px;
        }

        .freelancing-container .flex {
          display:flex;
          justify-content: space-between;
          align-items: center;
        }

        .freelancing-container .flex img {
        width:50%;
        height:auto;
        }
    </style>
</head>
<body>
      <div class="freelancing-container">
      ${this.generatedText.reply}
    </div>
</body>
</html>
`;
    },
  },
  computed: {
    ...mapGetters(['getUserProfile']),
  },
  mounted() {
    this.getSingleJob();
    if (localStorage.getItem('applyId')) {
      localStorage.removeItem('applyId');
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables';

.nofprmat {
  text-transform: none !important;
}

.fake-link {
  display: block;
  max-width: 250px;
}

.apply-documents {
  li {
    padding: 5px 15px;
    .custom-checkbox {
      overflow: hidden;
      display: flex;
      p {
        position: relative;
        padding-left: 18px;
        i {
          position: absolute;
          top: 4px;
          left: 0;
          margin-right: 5px;
        }
      }
    }
  }
}

.job-ad {
  .sticky-top {
    top: 30px;
  }
  padding-bottom: 30px;
  .to-jobs {
    display: block;
    margin: 20px 0 12px 0;
    font-weight: 700;
    font-size: 14px;
    text-decoration: none;
    color: #0088cc;
    cursor: pointer;
  }
  font-family: $font-family-sans-lato;
  h1 {
    font-size: 32px;
    font-weight: 700;
    margin: 15px 0 12px 0;
  }
  .location,
  .employment,
  .type {
    margin-right: 20px;
    font-size: 14px;
    i {
      color: #777;
      margin-right: 5px;
    }
    a {
      text-decoration: none;
    }
  }
  .last {
    display: none;
  }
  .list-unstyled {
    list-style: circle;
    margin: 15px 0;
    li {
      margin-left: 20px;
      padding-left: 8px;
    }
  }
  .company-info {
    font-style: italic;
  }
  .btn-success {
    margin: 52px 0 12px 0;
    font-weight: 700;
    padding: 12px 0;
    font-size: 18px;
    &.applied {
      background: rgba(0, 0, 0, 0.5);
      border: none;
      box-shadow: none !important;
    }
  }
  .box {
    margin-top: 55px;
    .list-unstyled {
      list-style: none;
      li {
        margin: 0 0 12px 0;
        padding: 0;
        a {
          text-decoration: none;
          span {
            &:first-of-type {
              font-size: 18px;
              font-family: 'Lato', sans-serif;
              width: 100%;
            }
            &:nth-of-type(2) {
              font-size: 12px;
              color: #424242;
            }
          }
        }
      }
    }
    h3 {
      text-transform: uppercase;
      font-size: 18px;
      margin: 25px 0 12px 0;
      font-family: Montserrat, sans-serif;
    }
  }
}

/deep/ .job-filters {
  .vs--searchable .vs__dropdown-toggle {
    height: 38px;
  }
  .vs__search {
    padding-top: 2px !important;
  }

  .aligment {
    width: 60%;
  }
  .aligment-secondary {
    flex: 1;
    margin-left: 12px;
  }
  .form-control {
    color: #777;
  }
  .btn-danger {
    align-self: flex-end;
    font-family: Lato, Roboto, 'Helvetica Neue', Arial, sans-serif;
    color: #fff;
    background-color: #f26622;
    border-color: #f26622;
    margin: 0 0 16px 12px;
  }
}

.latest-ads {
  padding: 20px 0;
  h2 {
    text-transform: uppercase;
    font-size: 21px;
    margin-bottom: 40px;
  }
  .single {
    padding: 5px;
    background: #fff;
    box-shadow: 0px 15px 35px #0000000d;
    margin-bottom: 20px;
    font-family: $font-family-sans-lato;
    img {
      width: 70px;
      height: 70px;
      object-fit: cover;
      object-position: center;
      overflow: hidden;
      margin-right: 12px;
      flex-shrink: 0;
    }
    .job-info {
      width: 37%;
      margin-right: 12px;
      a {
        display: block;
        text-decoration: none;
        &:first-of-type {
          font-size: 18px;
        }
        &:nth-of-type(2) {
          color: #424242;
          font-size: 16px;
        }
      }
    }
    .location {
      text-align: center;
      width: 130px;
      margin: 0 10px;
      a {
        text-decoration: none;
      }
      i {
        display: block;
        color: #afafaf;
        font-size: 18px;
        margin-bottom: 5px;
      }
      span {
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        text-transform: uppercase;
      }
    }
    .tagline {
      text-align: right;
      width: 200px;
      a {
        display: inline-block;
        background: #f2f2f2;
        border-radius: 16px;
        color: #3e3e3e;
        border: 5px solid #fff;
        font-size: 13px;
        padding: 3px 8px;
        text-decoration: none;
        font-weight: 500;
      }
    }
  }
}

/* Media queries */

@media only screen and (min-width: 1000px) {
  .modal.show .modal-dialog {
    min-width: 660px;
  }
}

@media only screen and (max-width: 992px) {
  .job-filters {
    display: block !important;
    .aligment {
      width: 100%;
    }
    .aligment-secondary {
      flex: 1;
      margin-left: 0px;
    }
  }
  .fake-link {
    display: block;
    max-width: 400px;
  }
}

@media only screen and (max-width: 576px) {
  .job-filters {
    .aligment {
      width: 100%;
    }
    .aligment-secondary {
      flex: 1;
      margin-left: 0px;
    }
  }
  .latest-ads {
    .single {
      flex-wrap: wrap;
      img {
        display: none;
      }
      .job-info {
        width: 100%;
        margin-bottom: 12px;
      }
      .tagline {
        margin: 12px 0 0 0 !important;
        width: 100%;
        text-align: center;
      }
      .location {
        margin: 0;
        color: #666;
        width: 48%;
        text-align: left;
        i {
          display: none;
        }
        &:nth-last-of-type(2) {
          text-align: right;
        }
      }
    }
  }
}
</style>
